<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42.5 22.5h-4.58A14 14 0 0025.5 10.08V5.5a1.5 1.5 0 00-3 0v4.58A14 14 0 0010.08 22.5H5.5a1.5 1.5 0 000 3h4.58A14 14 0 0022.5 37.92v4.58a1.5 1.5 0 003 0v-4.58A14 14 0 0037.92 25.5h4.58a1.5 1.5 0 000-3zM24 35a11 11 0 1111-11 11 11 0 01-11 11z"/></svg>